import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDebouncedLoader } from 'use-debounced-loader';

import RotatingRingIcon from './RotatingRingIcon';
import socialLinkButtonStyles from './SocialLinkButton.module.scss';
import styles from './index.module.scss';

export type Props = {
  readonly isDisabled?: boolean;
  readonly isLoading?: boolean;
  readonly className?: string;
  readonly target: string;
  readonly logo: string;
  readonly name: Record<string, string>;
  readonly onClick?: () => void;
  readonly isLastUsed?: boolean;
};

const SocialLinkButton = ({
  isDisabled,
  isLoading = false,
  className,
  target,
  name,
  logo,
  onClick,
  isLastUsed,
}: Props) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  let localName = name[language] ?? name.en ?? '';
  localName = localName.toLocaleLowerCase() === 'line' ? 'LINE' : localName;

  const isLoadingActive = useDebouncedLoader(isLoading, 300);

  return (
    <button
      disabled={isDisabled}
      className={classNames(
        styles.button,
        styles.secondary,
        styles.large,
        socialLinkButtonStyles.socialButton,
        (isDisabled ?? isLoadingActive) && styles.disabled,
        className
      )}
      type="button"
      onClick={onClick}
      title={t('action.sign_in_with', { name: localName })}
      aria-label={t('action.sign_in_with', { name: localName })}
    >
      {isLastUsed && (
        <span
          className={classNames(socialLinkButtonStyles.lastUsedBadge, language !== 'th' ? socialLinkButtonStyles.lastUsedBadgeEn : '')}
        >
          {t('other.last_used')}
        </span>
      )}
      {logo && !isLoadingActive && (
        <img src={logo} alt="" className={socialLinkButtonStyles.icon} />
      )}
      {isLoadingActive && (
        <span className={socialLinkButtonStyles.loadingIcon}>
          <RotatingRingIcon />
        </span>
      )}
      <div style={{ display: 'none' }} className={socialLinkButtonStyles.name}>
        <div className={socialLinkButtonStyles.placeHolder} />
        <span>{t('action.sign_in_with', { name: localName === 'Line' ? 'LINE' : localName })}</span>
        <div className={socialLinkButtonStyles.placeHolder} />
      </div>
    </button>
  );
};

export default SocialLinkButton;
